import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../lib/i18n";
import ExpenseSubmit from "./expenses/ExpenseSubmit";
import ExpenseApproval from "./expenses/ExpenseApproval";
import ExpenseDashboard from "./expenses/ExpenseDashboard";

export default function Expenses() {
  const { user } = useAuth();
  const { t } = useI18n();
  const canManage = ["admin", "supervisor"].includes(user?.role);
  const [tab, setTab] = useState("submit");
  const [data, setData] = useState({ ranches: [], employees: [], jobcodes: [], equipment: [], categories: [] });

  useEffect(() => {
    (async () => {
      try {
        const [r, e, j, eq, c] = await Promise.all([
          api.get("/ranches"), api.get("/employees"), api.get("/jobcodes"),
          api.get("/equipment"), api.get("/expenses/categories"),
        ]);
        setData({ ranches: r.data, employees: e.data, jobcodes: j.data, equipment: eq.data, categories: c.data.categories });
      } catch { /* ignore */ }
    })();
  }, []);

  const tabs = [["submit", t("exps.tab_submit")]];
  if (canManage) { tabs.push(["approval", t("exps.tab_approval")]); tabs.push(["dashboard", t("exps.tab_dashboard")]); }

  return (
    <div className="space-y-6" data-testid="expenses-page">
      <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight" style={{ fontFamily: "'Fraunces', serif" }}>{t("exps.title")}</h1>

      {tabs.length > 1 && (
        <div className="inline-flex border border-stone-200 bg-white p-1" data-testid="expense-tabs">
          {tabs.map(([k, label]) => (
            <button key={k} data-testid={`exp-tab-${k}`} onClick={() => setTab(k)}
              className={`h-11 px-5 font-bold uppercase text-xs tracking-wide transition-colors ${tab === k ? "bg-[#1F3D34] text-white" : "text-stone-600 hover:text-[#1F3D34]"}`}>
              {label}
            </button>
          ))}
        </div>
      )}

      {tab === "submit" && <ExpenseSubmit {...data} onSubmitted={() => canManage && setTab("approval")} />}
      {tab === "approval" && canManage && <ExpenseApproval />}
      {tab === "dashboard" && canManage && <ExpenseDashboard ranches={data.ranches} employees={data.employees} jobcodes={data.jobcodes} categories={data.categories} />}
    </div>
  );
}
